import React, { Component } from "react";
import { Button, Image } from "react-bootstrap";
import QRCode from "react-qr-code";
import ReactToPrint from "react-to-print";
import StickerQrComponent from "./StickerQrComponent";
import TableTentCardComponent from "./TableTentCardComponent";

class PrintComponentAdmin extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div
          className="shadow-sm p-4 bg-white rounded border"
          style={{
            minHeight: "500px",
          }}
        >
          <div
            id="style-4"
            className="p-4 bg-white rounded"
            style={{
              border: "1px solid #707070",
              // background: "#E5E5E5",
              overflowY: "scroll",
              maxHeight: this.props.qrCodeType === "Sticker" ? "500px" : "auto",
            }}
          >
            <ComponentToPrint
              ref={(el) => (this.componentRef = el)}
              qrData={this.props.qrData}
              restaurantName={this.props.restaurantName}
              restaurantLogo={this.props.restaurantLogo}
              qrCodeType={this.props.qrCodeType}
              {...this.props}
            />
          </div>
        </div>
        <div className="d-flexalign-items-center py-4">
          <Button
            variant="outline-secondary"
            className="btn-md mr-4 px-5"
            onClick={() => {
              this.props.setOpenPrintPreview(false);
            }}
          >
            Cancel
          </Button>
          <ReactToPrint
            trigger={() => (
              <Button variant="danger" type="button" className="btn-md px-5">
                Print
              </Button>
            )}
            content={() => this.componentRef}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default PrintComponentAdmin;

class ComponentToPrint extends Component {
  constructor(props) {
    super();
    this.state = {};
  }

  render() {
    let pagenumbers = this.props.qrData.map((data, index) => index);
    let numberPerPages =
      parseInt(pagenumbers.length / 6) === 0
        ? 1
        : parseInt(pagenumbers.length / 6);
    // console.log(pagenumbers, Math.ceil(pagenumbers.length / numberPerPages));
    return (
      <div className="row row-cols-1 row-cols-md-3">
        {/* //p-3 */}
        {this.props &&
          this.props.qrData &&
          this.props.qrData.map((data, index) => {
            return this.props?.qrCodeType === "Sticker" ? (
              <StickerQrComponent
                keysData={index}
                qrData={data}
                sizeData={this.props?.size}
                logo={this.props?.restaurantLogo}
                name={this.props?.restaurantName}
              />
            ) : (
              <TableTentCardComponent
                keysData={index}
                qrData={data}
                sizeData={this.props?.size}
                logo={this.props?.restaurantLogo}
                name={this.props?.restaurantName}
              />
            );

            // <>
            //   <div className="col-4 col-md-4 p-0 m-0" key={index}>
            //     <div
            //       style={{
            //         background: "#FFFFFF",
            //         // height: "100%",
            //         width: "100%",
            //         // overflowY: "scroll",
            //       }}
            //       //   id="printme divtoprint"
            //       //   style={{
            //       // boxShadow: "0px 3px 6px #00000029",
            //       //   }}
            //       //   className="d-flex justify-content-center "
            //     >
            //       <div
            //       // className="h-100"
            //       // align="center"
            //       >
            //         <div
            //           // className="QRInner-onboarding p-4"
            //           className="p-4 "
            //           style={{ minHeight: "250px" }}
            //         >
            //           <div
            //             className="d-flex align-items-center justify-content-center border"
            //             style={{ minHeight: "200px" }}
            //           >
            //             <div>
            //               <div className="text-center">
            //                 <QRCode
            //                   bgColor="#FFFFFF"
            //                   fgColor="#000000"
            //                   size={this.props?.size || 150}
            //                   level="H"
            //                   value={
            //                     typeof data === "object"
            //                       ? JSON.stringify(data)
            //                       : data
            //                       ? data
            //                       : JSON.stringify({ status: false })
            //                   }
            //                 />
            //               </div>
            //               <div className="col-12 text-center mt-3">
            //                 <p className="f11-400">
            //                   {data?.table_number !== undefined &&
            //                   data?.table_number !== null &&
            //                   data?.table_number !== ""
            //                     ? "Table Number : "
            //                     : null}
            //                   <span className="f11-500">
            //                     {data?.table_number !== undefined &&
            //                     data?.table_number !== null &&
            //                     data?.table_number !== ""
            //                       ? data?.table_number
            //                       : null}
            //                   </span>
            //                 </p>
            //               </div>
            //             </div>
            //           </div>
            //         </div>
            //       </div>
            //     </div>
            //   </div>
            //   {((this?.props?.qrData?.length > 6 &&
            //     Number.isInteger((index + 1) / 6) &&
            //     index !== 0) ||
            //     this?.props?.qrData?.length === index + 1) && (
            //     <div className="col-12 mt-2 mb-2 text-center f12-500">
            //       Page{" "}
            //       {parseInt((index + 1) / 6) === 0
            //         ? 1
            //         : Number.isInteger((index + 1) / 6)
            //         ? parseInt((index + 1) / 6)
            //         : parseInt((index + 1) / 6) + 1}{" "}
            //       of{" "}
            //       {parseInt(this?.props?.qrData?.length / 6) === 0
            //         ? 1
            //         : Math.ceil(this?.props?.qrData?.length / 6)}
            //     </div>
            //   )}
            // </>
          })}
      </div>
    );
  }
}
